var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-email-wrap"},[(_vm.details)?_c('email-details',{attrs:{"details":_vm.details}}):_c('create-email'),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"email-loader"},[_c('img',{attrs:{"src":"/css/img/loading.gif"}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }